module.exports = "/images/retirement.png?6438d57563b1824dc5d9da12db83d1e1";